import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class RoleSystemName extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            key: this.props.value || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            key: nextProps.value || '',
        })
    }

    render() {
        switch (this.state.key) {
            case 'admin':
                return <FormattedMessage
                    id="common.role.admin_label"
                    defaultMessage="Admin"
                />
            case 'sales-man':
                return <FormattedMessage
                    id="common.role.sales_person_label"
                    defaultMessage="Salesperson"
                />
            default:
                return this.state.key
        }
    }
}

export default RoleSystemName





// WEBPACK FOOTER //
// ./src/role/systemname.component.jsx